import React, { useEffect, useState } from 'react'
import { IconTimelineApproved, IconTimelineClock, IconTimelineMail, IconTimelinePending, IconTimelineRecipient, IconTimelineRejected } from '../iconSet/IconSet'
import { TimelineElementPropsType } from '../earlyWarning/emailComp/EmailTypes';
import { APICallGetUserInfoRequest, APIGetUserDetailsTypes } from '../../services/APIEarlyWarningService';
import { formatTimestamp } from './WarningWorkflowProcess';

const warningTypeMap: Record<string, string> = {
    LSW: "landslide warning",
    HRW: "heavy rain warning",
    LIG: "severer lightning warning",
    MWA: "marine weather warning",
    NTW: "nuclear threat warning",
    ASW: "air strike warning",
    HWN: "high wind warning",
    FLW: "flood warning",
    TW: "Tsunami warning",
    CUS: "Custom warning",
    GUS: "Gust wind warning"
};

const TimelineElement = (props: TimelineElementPropsType) => {

    //const users: APIGetUserDetailsTypes[] = []
    //const [users, setUsers] = useState<APIGetUserDetailsTypes>()

    /* useEffect(() => {   
        const fetchUser = async () => {
            try {
                const user = await APICallGetUserInfoRequest(props.data.performedUser);
                setUsers(user);
            } catch (error) {
                console.error("Failed to fetch user info:", error);
            }
        };

        if (props.data?.performedUser) {
            fetchUser();
        }
    }, [props.data]); */

    useEffect(() => {
        //console.log(">>>>>>>>>>>>>>> DATA: ", props.data)
        //console.log(">>>>>>>>>>>>>>>>> WARNING: ", props.warning)
    }, [props.data, props.warning])
    return (
        <>
            <div className='left'>
                
                {props.data.status === 'PENDING' && (
                    <div className='icon-bg blinking-opacity' style={{backgroundColor: 'var(--color-main-red)'}}>
                        <IconTimelinePending width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {props.data.status === 'ACCEPTED' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-blue)'}}>
                        <IconTimelineApproved width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {props.data.status === 'REJECTED' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-red)'}}>
                        <IconTimelineRejected width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {/* {props.data.status === 'RECIPIENT' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-blue)'}}>
                        <IconTimelineRecipient width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )} */}
                {props.data.status === 'INITIATE' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-blue)'}}>
                        <IconTimelineMail width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {props.data.status === 'FINALIZE' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-blue)'}}>
                        <IconTimelineApproved width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {/* ADD: add new type for system approval types */}
                {props.data.status === 'SYSTEM' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-blue)'}}>
                        <IconTimelineApproved width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                {props.data.status === 'AWAITING_PENDING' && (
                    <div className='icon-bg' style={{backgroundColor: 'var(--color-main-green)'}}>
                        <IconTimelinePending width='1.5rem' color='var(--color-main-white)'/>
                    </div>
                )}
                
            </div>
            <div className='right'>
                <div className='message'>
                    <div className='message-header'>
                        <div>
                            {props.data.status === 'REJECTED' && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-red)', textTransform: 'capitalize'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-main-red)', textTransform: 'capitalize'}}>({props.data.userRole} - {props.data.department})</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}>Rejecting for issuing {warningTypeMap[props.data && props.data.warningType]}</span>
                                </>
                                
                            )}
                            {props.data.status === 'PENDING' && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-red)', textTransform: 'capitalize'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-main-red)', textTransform: 'capitalize'}}>({props.data.userRole} - {props.data.department})</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}>Awaiting for pending approval {warningTypeMap[props.data && props.data.warningType]} awaiting for accepting</span>
                                </>
                                
                            )}
                            {props.data.status === 'INITIATE' && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>({props.data.userRole} - {props.data.department})</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}>Request for issuing {warningTypeMap[props.data && props.data.warningType]}</span>
                                </>
                                
                            )}
                            {props.data.status === 'ACCEPTED' && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>({props.data.userRole} - {props.data.department})</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}>Approved for {warningTypeMap[props.data && props.data.warningType]}</span>
                                </>
                                
                            )}
                            {/* {props.data.status === 'SYSTEM' && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-green)'}}>{props.data.userRole}</span>
                                    <span className='post' style={{color: 'var(--color-main-green)'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}>Approved for {warningTypeMap[props.data && props.data.warningType]}</span>
                                </>
                                
                            )} */}
                            
                            {/* {props.data.status === 'RECIPIENT' && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-green)'}}>{props.data.userRole}</span>
                                    <span className='post' style={{color: 'var(--color-main-green)'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}>Add recipient {warningTypeMap[props.data && props.data.warningType]} </span>
                                </>
                            )} */}

                            {(props.data.status === 'FINALIZE' || props.data.status === 'SYSTEM') && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-main-blue)', textTransform: 'capitalize'}}>({props.data.userRole} - {props.data.department})</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}> Final approved {warningTypeMap[props.data && props.data.warningType]} </span>
                                </>
                            )}
                            {(props.data.status === 'AWAITING_PENDING') && (
                                <>
                                    <span className='post' style={{color: 'var(--color-main-green)', textTransform: 'capitalize'}}>{props.data && props.data.performedUser}</span>
                                    <span className='post' style={{color: 'var(--color-main-green)', textTransform: 'capitalize'}}>({props.data.userRole} - {props.data.department})</span>
                                    <span className='post' style={{color: 'var(--color-text)'}}> Awaiting for pending {warningTypeMap[props.data && props.data.warningType]} </span>
                                </>
                            )}
                        </div>
                        {props.data.status !== 'RECIPIENT' && (
                            <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                                <IconTimelineClock width='1rem' color='var(--color-text)'/>
                                <span style={{fontSize: '0.7rem', color: 'var(--color-text)'}}>{props.data && formatTimestamp(props.data.performedDate)}</span>
                            </div>
                        )}
                        
                    </div>

                    <div>
                        {props.data.status === 'INITIATE' && (
                            <div className='body'>
                                <span className='body-data'>Requesting for declaring {warningTypeMap[props.data && props.data.warningType]} ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}. awaiting....</span>
                            </div>
                        )}
                        {props.data.status === 'PENDING' && (
                            <div className='body'>
                                <span className='body-data'>Pending {warningTypeMap[props.data && props.data.warningType]} ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}. awaiting....</span>
                            </div>
                        )}
                        {props.data.status === 'ACCEPTED' && (
                            <div className='body'>
                                <span className='body-data'>Approved for  {warningTypeMap[props.data && props.data.warningType]}  ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}. Remarks:</span>
                            </div>
                        )}
                        {/* {props.data.status === 'RECIPIENT' && (
                            <div className='body'>
                                <span className='body-data'>Add recipient for  {warningTypeMap[props.data && props.data.warningType]}  ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}. Remarks:</span>
                            </div>
                        )} */}
                        {/* {props.data.status === 'FINALIZE' && (
                            <div className='body'>
                                <span className='body-data'>Approved for  {warningTypeMap[props.data && props.data.warningType]}  ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}. Remarks:</span>
                            </div>
                        )} */}
                        {props.data.status === 'REJECTED' && (
                            <div className='body'>
                                <span className='body-data'>Reject for  {warningTypeMap[props.data && props.data.warningType]}  ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}. Remarks:</span>
                            </div>
                        )}
                        {(props.data.status === 'FINALIZE' || props.data.status === 'SYSTEM') && (
                            <div className='body'>
                                <span className='body-data'>Approved for  {warningTypeMap[props.data && props.data.warningType]}  ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}</span>
                            </div>
                        )}
                        {(props.data.status === 'AWAITING_PENDING') && (
                            <div className='body'>
                                <span className='body-data'>awaiting for  {warningTypeMap[props.data && props.data.warningType]} ({props.warning && props.warning.warningNumber}) on {props.data && formatTimestamp(props.data.performedDate)}</span>
                            </div>
                        )}
                    </div>
                    
                    {props.data.status !== 'RECIPIENT' && (
                        <>
                            {(props.data.status === 'PENDING') && (
                                <div className='tag-container'>
                                    {props.data.userEmail && (
                                        <div style={{backgroundColor: 'var(--color-main-red)'}}>
                                            <span className='label'>email:</span>
                                            <span className='data'>{props.data.userEmail}</span>
                                        </div>
                                    )}
                                    {props.data.userContact && (
                                        <div style={{backgroundColor: 'var(--color-main-red)'}}>
                                            <span className='label'>mobile:</span>
                                            <span className='data'>{props.data.userContact}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                            {(props.data.status === 'AWAITING_PENDING') && (
                                <div className='tag-container'>
                                    {props.data.userEmail && (
                                        <div style={{backgroundColor: 'var(--color-main-green)'}}>
                                            <span className='label'>email:</span>
                                            <span className='data'>{props.data.userEmail}</span>
                                        </div>
                                    )}
                                    {props.data.userContact && (
                                        <div style={{backgroundColor: 'var(--color-main-green)'}}>
                                            <span className='label'>mobile:</span>
                                            <span className='data'>{props.data.userContact}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                            {(props.data.status === 'INITIATE' || props.data.status === 'FINALIZE' || props.data.status === 'SYSTEM' || props.data.status === 'ACCEPTED') && (
                                <div className='tag-container'>
                                    {props.data.userEmail && (
                                        <div style={{backgroundColor: 'var(--color-main-blue)'}}>
                                            <span className='label'>email:</span>
                                            <span className='data'>{props.data.userEmail}</span>
                                        </div>
                                    )}
                                    {props.data.userContact && (
                                        <div style={{backgroundColor: 'var(--color-main-blue)'}}>
                                            <span className='label'>mobile:</span>
                                            <span className='data'>{props.data.userContact}</span>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                        
                    )}
                </div>
            </div>
        </>
    )
}

export default TimelineElement